import { Reveal } from "../components/Reveal";
import { useModal } from "../context/ModalContext";
import { useSettings } from "../context/SettingsContext";
import { CalendarCheck, Phone, MessageCircle } from "lucide-react";

export function FinalCta() {
  const { open } = useModal();
  const { settings } = useSettings();
  const wa = settings.whatsapp || "https://wa.me/447956120510";

  return (
    <section className="py-20" data-testid="final-cta-section">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <Reveal>
          <div className="relative overflow-hidden rounded-[2rem] sm:rounded-[2.5rem] brand-gradient px-5 py-12 sm:px-16 sm:py-16 text-center text-white grain">
            <div className="absolute top-0 left-1/4 w-72 h-72 bg-white/10 rounded-full blur-3xl" />
            <div className="relative">
              <h2 className="font-heading text-3xl sm:text-5xl font-extrabold tracking-tight max-w-2xl mx-auto leading-tight">
                Ready to start your driving journey?
              </h2>
              <p className="mt-4 text-white/90 max-w-xl mx-auto text-lg">
                Book your first lesson today or get a free, no-obligation quote in under a minute.
              </p>
              <div className="mt-8 flex flex-col sm:flex-row sm:flex-wrap gap-3 justify-center">
                <button className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full bg-white text-brand-red font-bold px-6 py-3.5 hover:scale-105 transition-transform" onClick={() => open("booking")} data-testid="final-book-btn">
                  <CalendarCheck size={18} /> Book Lesson
                </button>
                <button className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full bg-neutral-900 text-white font-bold px-6 py-3.5 hover:scale-105 transition-transform" onClick={() => open("quote")} data-testid="final-quote-btn">
                  Get Free Quote
                </button>
                <a href={`tel:${settings.phone_link || ""}`} className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full border-2 border-white/70 text-white font-bold px-6 py-3.5 hover:scale-105 hover:border-white hover:bg-white/10 transition-all duration-300" data-testid="final-call-btn">
                  <Phone size={18} /> Call Now
                </a>
                <a href={wa} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] text-white font-bold px-6 py-3.5 hover:scale-105 transition-transform" data-testid="final-whatsapp-btn">
                  <MessageCircle size={18} /> WhatsApp
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
